import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
import {
  Grid,
  Toolbar,
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  List,
  Divider,
} from "@mui/material";
import MonitorHeartIcon from "../../Assets/images/monitor.svg"; //'@mui/icons-material/MonitorHeart';
import CoPresentIcon from "../../Assets/images/virtual.svg"; //'@mui/icons-material/CoPresent';
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import VitalsDashboardIcon from "../../Assets/images/vitalsDashboard.svg";
import { withTranslation } from "react-i18next";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import { LocalStorageSetValue } from "../../Services/Auth";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { resetCall } from "../../Redux/Actions/callActions";
import { connect } from "react-redux";
import User2 from "../../Assets/images/SVGS/3 User 2.svg";
import Group883486 from "../../Assets/images/SVGS/Group 883486.svg";
import ConferenceIcon from "../../Assets/images/ConferenceIcon.svg";
import ConferenceOnlineIcon from "../../Assets/images/ConferenceOnlineIcon.svg";
import { version } from "../../../package.json";
import * as firebaseConfig from "../../firebase-config";
import ArchiveIcon from "../../Assets/images/archivedDetails/Archive.svg";
import { getZoomMeeting } from "../../Services/ZoomMeeting";
import { ToggleOnlineConference } from "../../Redux/Actions/checkZoomDetails";
import { isRoundingNotesEnabled } from "../../Services/MultidisciplinaryRounding";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
const styles = (theme) => ({
  root: {
    display: "flex",
  },
  footerList: {
    position: "absolute",
    bottom: 0,
  },
  footerCloseList: {
    position: "absolute",
    bottom: 0,
  },
  listbuttonitem: {
    paddingLeft: "12px",
    paddingRight: "12px",
    // 2026-07 refresh: flex-flow nav items (label was absolutely positioned
    // at left:60px) with a purple-tint hover/selected system on the navy rail.
    transition: "background-color 180ms cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "rgba(155, 81, 224, 0.08)",
    },
  },
  listtextitem: {
    marginLeft: "14px",
    minWidth: 0,
    whiteSpace: "nowrap",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  listiconitem: {
    minWidth: "24px",
    width: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  listiconitemclose: {
    minWidth: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  button: {
    marginTop: 10,
    marginBottom: 10,
    textTransform: "inherit",
    color: "white",
    fontFamily: "Poppins",
    fontWeight: 600,
    borderRadius: 8,

    "&:hover": {
      backgroundColor: "rgba(155, 81, 224, 0.08)",
    },
  },
});

// Selected nav item on the dark navy rail: soft primary tint only — no
// left spine (it reads as a stray bracket against the rounded corners).
const selectedItemStyle = {
  backgroundColor: "rgba(155, 81, 224, 0.18)",
};

// Hoisted from render: the footer copy never changes at runtime.
const COPYRIGHT_LINE = `Copyright ©${new Date().getFullYear()} Omnicure`;
const VERSION_LINE =
  "v" +
  version.replace(
    /(\d+)\.(\d+)\.(\d+)(-rc\.(\d))?/,
    version.includes("-rc") ? `$1.$2.$3(0.$5)` : `$1.$2.$3`
  ) +
  ` ${firebaseConfig.firebaseConfig.projectId
    ?.replace("omnicure", "")
    ?.replace("-", "")
    ?.toUpperCase()}`;

class Sidebar extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: "",
      isDrawer: props.isDrawer,
      // multimonitor:sessionStorage.getItem("multiMonUrl"),
      // virtualOPS:sessionStorage.getItem("virtualOpsUrl"),
      currentPath: sessionStorage.getItem("currentPath"),
    };
  }

  componentDidUpdate(prevState, currentState) {
    if (prevState.isDrawer !== this.props.isDrawer) {
      this.setState({ isDrawer: this.props.isDrawer });
    }
  }
  componentDidMount() {
    const { userId } =
      /*JSON.parse(LocalStorageGetValue("userDetails"))*/ this.props
        .providerData;
    getZoomMeeting({ id: userId })
      .then((data) => {
        const activeZoom = data.some(({ status }) => status === "Active");
        this.props.toggleZoomStatus(activeZoom);
      })
      .catch((err) => {});
  }
  openWithNewTab = (path, urls) => {
    if (path === "Multi") {
      const url = urls;
      if (url) {
        // Check if the URL is already absolute path else have to add, if its not an absolute path then default it took the base application url and override happening to avoid the visibility
        const absoluteUrl =
          url.startsWith("http://") || url.startsWith("https://")
            ? url
            : `https://${url}`; // Prepend with 'https://' or another default protocol if needed

        window.open(absoluteUrl, "_blank");
      }
    } else {
      const url = urls;
      if (url) {
        // Check if the URL is already absolute path else have to add, if its not an absolute path then default it took the base application url and override happening to avoid the visibility
        const absoluteUrl =
          url.startsWith("http://") || url.startsWith("https://")
            ? url
            : `https://${url}`; // Prepend with 'https://' or another default protocol if needed

        window.open(absoluteUrl, "_blank");
      }
    }
  };
  redirect = (menu) => {
    if (this.props.location.pathname === menu.url) {
      return;
    }
    if (menu.name === "Multi Mon") {
      this.openWithNewTab("Multi", menu.url);
      return;
    }
    if (menu.name === "Virtual Ops") {
      this.openWithNewTab("Virtual", menu.url);
      return;
    }

    this.props.resetBreadCrumbState();
    LocalStorageSetValue("navigationPath", []);
    LocalStorageSetValue("currentPatient", "");
    this.setState({ selectedMenu: menu });
    if (menu.elementId === "signout") {
      this.props.resetCall();
      this.props.logout();
    } else {
      let { url } = menu;
      this.props.history.push(url);
      this.setState({ currentPath: url });
      sessionStorage.setItem("currentPath", url);
      window.history.replaceState(null, "", "/");
    }
  };

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const userDetails =
      /*JSON.parse(LocalStorageGetValue("userDetails"))*/ this.props
        .providerData;
    const scheduleUrl =
      this.props?.hospitalDetails?.scheduleUrl ||
      sessionStorage.getItem("scheduleUrl") ||
      userDetails?.scheduleUrl ||
      "";

    const hasScheduleUrl = scheduleUrl && scheduleUrl.trim() !== "";
    const { role } = userDetails;
    const isRP = role === "RD";
    const showScheduleMenu = isRP || hasScheduleUrl;
    console.log("WEB providerData", userDetails);
    console.log("WEB scheduleUrl", scheduleUrl);
    const roundingNotesEnabled = isRoundingNotesEnabled(userDetails);
    const multiMonitorAccess = sessionStorage.getItem("multiMonUrl");
    const virttualOPSAccess = sessionStorage.getItem("virtualOpsUrl");
    const routeData = [
      {
        key: 1,
        name: "My eConsults",
        url: "/dashboard",
        icon: <img alt="side" src={Group883486} />,
        ariaLabel: "Dashboard",
        elementId: "dashboard",
      },
      {
        key: 2,
        name: "Patient Census",
        url: "/patientCensus",
        icon: <img alt="side" src={User2} />,
        ariaLabel: "patientCensus",
        elementId: "patientCensus",
      },
      {
        key: 3,
        name: "Vitals Dashboard",
        url: "/vitalsDashboard",
        icon: <img alt="side" src={VitalsDashboardIcon} />,
        ariaLabel: "vitalsDashboard",
        elementId: "vitalsDashboard",
      },
      ...(roundingNotesEnabled
        ? [
            {
              key: 6,
              name: "Rounding Notes",
              url: "/roundingNotes",
              activeUrls: ["/roundingNotes", "/roundingNotesLocal"],
              icon: (
                <AssignmentOutlinedIcon
                  style={{ color: "#FFF", fontSize: 22 }}
                />
              ),
              ariaLabel: "Rounding Notes",
              elementId: "roundingNotes",
            },
          ]
        : []),
      ...(role === "RD"
        ? [
            {
              key: 4,
              name: "Archived Patients",
              url: "/archiveHomepage",
              icon: <img alt="side" src={ArchiveIcon} />,
              ariaLabel: "patientArchive",
              elementId: "patientArchive",
            },
          ]
        : []),
      ...(multiMonitorAccess
        ? [
            {
              key: 5,
              name: "Multi Mon",
              url: multiMonitorAccess,
              icon: <img alt="side" src={MonitorHeartIcon} />,
              ariaLabel: "MuliMonitor",
              elementId: "MulttiMonitor",
            },
          ]
        : []),
      ...(virttualOPSAccess
        ? [
            {
              key: 5,
              name: "Virtual Ops",
              url: virttualOPSAccess,
              icon: <img alt="side" src={CoPresentIcon} />,
              ariaLabel: "VirtualOPS",
              elementId: "VirtualOPS",
            },
          ]
        : []),
    ];
    const footerData = [
      {
        key: 5,
        name: "Conference",
        url: "/conference",
        icon: this.props.zoomConference ? (
          // translateX nudges removed: they compensated for the old
          // absolutely-positioned label layout and broke flex centering.
          <img alt="ConferenceIcon" src={ConferenceOnlineIcon} />
        ) : (
          <img alt="ConferenceIcon" src={ConferenceIcon} />
        ),
        ariaLabel: "Conference",
        elementId: "Conference",
      },
      {
        key: 1,
        name: t("providerDirectory.label"),
        url: "/provider-directory",
        icon: <BadgeOutlinedIcon style={{ fontSize: 22, color: "#ffffff" }} />,
        ariaLabel: "Provider Directory",
        elementId: "providerDirectory",
      },
      {
        key: 2,
        name: t("support.label"),
        url: "/support",
        icon: <SmsOutlinedIcon style={{ fontSize: 22, color: "#ffffff" }} />,
        ariaLabel: "Contact support",
        elementId: "support",
      },
      // {
      //   key: 3,
      //   name: t("feedback.label"),
      //   url: "/feedback",
      //   icon: <img alt="feedbackicon" src={feedbackIcon} />,
      //   ariaLabel: "feedback",
      //   elementId: "feedback",
      // },
      ...(showScheduleMenu
        ? [
            {
              key: 3,
              name: "Schedule",
              url: "/feedback",
              icon: (
                <FeedbackOutlinedIcon
                  style={{ fontSize: 22, color: "#ffffff" }}
                />
              ),
              ariaLabel: "schedule",
              elementId: "schedule",
            },
          ]
        : []),
      {
        key: 4,
        name: t("signOut.label"),
        url: "/signout",
        icon: <LogoutOutlinedIcon style={{ fontSize: 22, color: "#ffffff" }} />,
        ariaLabel: "sign out",
        elementId: "signout",
      },
    ];

    return (
      <>
        <Grid container spacing={0} style={{ height: "100%" }}>
          <Grid item xs={12} sm={12}>
            <List
              style={{ padding: "18px", position: "sticky", paddingBottom: 0 }}
            >
              {routeData.map((route, index) => (
                <ListItem
                  button
                  key={route.key}
                  className={classes.button}
                  classes={{ root: classes.listbuttonitem }}
                  style={{
                    ...(route.url === this.props.currentUrl ||
                    route.activeUrls?.includes(this.props.currentUrl)
                      ? selectedItemStyle
                      : {}),
                    fontFamily: "Poppins !important",
                    height: "44px",
                    borderRadius: "8px",
                    ...(this.props.sideBarClosed && {
                      paddingLeft: 0,
                      paddingRight: 0,
                    }),
                    position: "relative",
                  }}
                  onClick={() => this.redirect(route)}
                  aria-label={route.ariaLabel}
                  id={route.elementId}
                >
                  <ListItemIcon
                    classes={{
                      root: this.props.sideBarClosed
                        ? classes.listiconitemclose
                        : classes.listiconitem,
                    }}
                  >
                    {route.icon}
                  </ListItemIcon>
                  {!this.props.sideBarClosed && (
                    <ListItemText
                      classes={{ root: classes.listtextitem }}
                      primary={
                        <Typography className="content-emphasized-sidenav-text">
                          {route.name}
                        </Typography>
                      }
                    />
                  )}
                </ListItem>
              ))}

              {/* {multiMonitorAccess &&  <ListItem
                button
                key={5}
                className={classes.button}
                classes={{ root: classes.listbuttonitem }}
                style={{
                  backgroundColor: "",
                  fontFamily: "Poppins !important",
                  height: "44px",
                  borderRadius: "40px",
                  ...(this.props.sideBarClosed && {
                    paddingLeft: 0,
                    paddingRight: 0,
                  }),
                  position: "relative",
                }}
                onClick={() => this.openWithNewTab("Multi")}
                aria-label={"Multi Mon"}
                id={55}
              >
                <ListItemIcon
                  classes={{
                    root: this.props.sideBarClosed
                      ? classes.listiconitemclose
                      : classes.listiconitem,
                  }}
                >
                  {MonitorHeartIcon}
                </ListItemIcon>
                <ListItemText
                  classes={{ root: classes.listtextitem }}
                  style={this.props.sideBarClosed ? { display: "none" } : undefined}
                  primary={
                    <Typography
                      className="content-emphasized-sidenav-text"
                      style={{
                        ...(this.props.sideBarClosed && {
                          visibility: "hidden",
                        }),
                      }}
                    >
                      "Multi Mon"
                    </Typography>
                  }
                />
              </ListItem>}
              {virttualOPSAccess &&  <ListItem
                button
                key={6}
                className={classes.button}
                classes={{ root: classes.listbuttonitem }}
                style={{
                  backgroundColor: "",
                  fontFamily: "Poppins !important",
                  height: "44px",
                  borderRadius: "40px",
                  ...(this.props.sideBarClosed && {
                    paddingLeft: 0,
                    paddingRight: 0,
                  }),
                  position: "relative",
                }}
                onClick={() => this.openWithNewTab("Virtual")}
                aria-label={"Virtual OPS"}
                id={66}
              >
                <ListItemIcon
                  classes={{
                    root: this.props.sideBarClosed
                      ? classes.listiconitemclose
                      : classes.listiconitem,
                  }}
                >
                  {CoPresentIcon}
                </ListItemIcon>
                <ListItemText
                  classes={{ root: classes.listtextitem }}
                  style={this.props.sideBarClosed ? { display: "none" } : undefined}
                  primary={
                    <Typography
                      className="content-emphasized-sidenav-text"
                      style={{
                        ...(this.props.sideBarClosed && {
                          visibility: "hidden",
                        }),
                      }}
                    >
                      {"Virtual Ops"}
                    </Typography>
                  }
                />
              </ListItem>} */}
            </List>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            style={{ display: "flex", alignItems: "flex-end" }}
          >
            <List
              style={{
                padding: "18px",
                width: "100%",
                position: "sticky",
                paddingBottom: 0,
              }}
            >
              <Toolbar
                style={{
                  padding: 0,
                  minHeight: 10,
                }}
              >
                {this.state.isDrawer && (
                  <Divider style={{ background: "gray", width: "100%" }} />
                )}
              </Toolbar>
              {footerData.map((footer, index) => (
                <ListItem
                  button
                  key={footer.key}
                  aria-label={footer.ariaLabel}
                  id={footer.elementId}
                  className={classes.button}
                  classes={{ root: classes.listbuttonitem }}
                  style={{
                    ...(footer.url === this.props.currentUrl
                      ? selectedItemStyle
                      : {}),
                    fontFamily: "Poppins !important",
                    position: "inherit",
                    height: "44px",
                    borderRadius: "8px",
                    ...(this.props.sideBarClosed && {
                      paddingLeft: 0,
                      paddingRight: 0,
                    }),
                  }}
                  onClick={() => this.redirect(footer)}
                >
                  <ListItemIcon
                    classes={{
                      root: this.props.sideBarClosed
                        ? classes.listiconitemclose
                        : classes.listiconitem,
                    }}
                  >
                    {footer.icon}
                  </ListItemIcon>
                  {!this.props.sideBarClosed && (
                    <ListItemText
                      classes={{ root: classes.listtextitem }}
                      style={{ color: "white" }}
                      primary={
                        <Typography className="content-emphasized-sidenav-text">
                          {footer.name}
                        </Typography>
                      }
                    />
                  )}
                </ListItem>
              ))}

              <ListItem
                style={{
                  display: "flex",
                  justifyContent: "center",
                  position: "inherit",
                }}
                aria-label="Copy Right"
                id="copyright"
              >
                <div style={{ textAlign: "center", height: "50px" }}>
                  <Typography style={{ color: "#5E6C84", fontSize: 12 }}>
                    {this.state.isDrawer ? COPYRIGHT_LINE : " "}
                  </Typography>
                  <Typography style={{ color: "#5E6C84", fontSize: 12 }}>
                    {this.state.isDrawer ? "All Rights Reserved" : " "}
                  </Typography>
                  <Typography style={{ color: "#5E6C84", fontSize: 12 }}>
                    {this.state.isDrawer ? VERSION_LINE : " "}
                  </Typography>
                </div>
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </>
    );
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    zoomConference: state?.ZoomReducer.zoomConference,
    sideBarClosed: !state?.LeftMenuPanel.leftPanelExpanded,
    providerData: state?.providerDetailsReducer?.provider,
    hospitalDetails: state?.hospitalDetailsReducer?.hospital,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetBreadCrumbState() {
      dispatch({ type: "RESETBREADCRUMB" });
    },
    resetCall: () => dispatch(resetCall()),
    toggleZoomStatus(payload) {
      dispatch(ToggleOnlineConference(payload));
    },
  };
};

export default withTranslation()(
  withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Sidebar))
);
